import { render, staticRenderFns } from "./MutipleChoiceContent.vue?vue&type=template&id=3b492b86&scoped=true&"
import script from "./MutipleChoiceContent.vue?vue&type=script&lang=js&"
export * from "./MutipleChoiceContent.vue?vue&type=script&lang=js&"
import style0 from "./MutipleChoiceContent.vue?vue&type=style&index=0&id=3b492b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b492b86",
  null
  
)

export default component.exports